import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';
import CustomTooltip from './CustomTooltip';
import * as track from '../../../lib/track';

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: '1rem',
    marginBottom: '1rem',
    width: '10rem',
    cursor: 'pointer',
    border: '1px solid transparent',
    '&:hover': {
      border: `1px solid ${theme.palette.secondary.main}`,
    },
  },
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem',
    '&:last-child': {
      padding: '1rem',
    },
  },
  icon: {
    fontSize: '2.5rem',
  },
  name: {
    width: '100%',
    textAlign: 'center',
    marginTop: '0.75rem',
  },
}));

const PassportServiceCard = ({service}) => {
  const classes = useStyles();
  const history = useHistory();
  const onClick = () => {
    track.sendEvent('user account home page menu', 'click', {value: service.value});
    history.push({pathname: `/profile/${service.value}`, state: { service: service.value }});
  };
  return (
    <CustomTooltip
      arrow
      placement="bottom"
      title={service.description}
    >
      <Card className={classes.root} onClick={onClick}>
        <CardContent className={classes.content}>
          {React.cloneElement(service.icon, {className: classes.icon})}
          <Typography variant="subtitle2" className={classes.name}>
            {service.name}
          </Typography>
        </CardContent>
      </Card>
    </CustomTooltip>
  );
};

PassportServiceCard.propTypes = {
  service: PropTypes.object.isRequired,
};

export default PassportServiceCard;
